const es = {
  "extra": {
    "afterSalesExtra": {
      "config": {
        "title": "Extra Configuración",
        "list": "Lista de Configuración de Extras",
        "add": "Agregar Configuración",
        "addType": "Agregar tipo de extra",
        "manageTypes": "Gestionar tipos de extra",
        "viewTypes": "Ver tipos de extra",
        "modalAddTypeTitle": "Agregar Nuevo Tipo de Extra",
        "modalManageTypesTitle": "Gestión de Tipos de Extra",
        "deleteType": "Eliminar tipo de extra",
        "editType": "Editar tipo de extra",
        "edit": "Editar Configuración",
        "delete": "Eliminar Configuración",
        "fields": {
          "id": "ID",
          "startDate": "Fecha Inicio",
          "endDate": "Fecha Fin",
          "amount": "Importe",
          "extraType": "Tipo de Extra",
          "delegation": "Delegación",
          "className": "Clase de Extra"
        },
        "messages": {
          "confirmDelete": "¿Estás seguro de que deseas eliminar esta configuración?",
          "confirmDeleteType": "¿Estás seguro de que deseas eliminar este tipo de extra? Esta acción no se puede deshacer.",
          "successCreate": "Configuración creada correctamente",
          "successCreateType": "Tipo de extra creado correctamente",
          "successUpdateType": "Tipo de extra actualizado correctamente",
          "successDeleteType": "Tipo de extra eliminado correctamente",
          "successUpdate": "Configuración actualizada correctamente",
          "successDelete": "Configuración eliminada correctamente"
        }
      },
      "validation": {
        "status": {
          "pending": "Pendiente",
          "approved": "Aprobada",
          "rejected": "Rechazada",
          "cancelled": "Cancelada"
        }
      }
    }
  }
};

export default es;
